import { render, staticRenderFns } from "./firstQuestion.vue?vue&type=template&id=2573d764&scoped=true"
import script from "./firstQuestion.vue?vue&type=script&lang=js"
export * from "./firstQuestion.vue?vue&type=script&lang=js"
import style0 from "./firstQuestion.vue?vue&type=style&index=0&id=2573d764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573d764",
  null
  
)

export default component.exports